import { render, staticRenderFns } from "./PerfilUsuarioDetalhes.vue?vue&type=template&id=71c8bc94&"
import script from "./PerfilUsuarioDetalhes.vue?vue&type=script&lang=js&"
export * from "./PerfilUsuarioDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./PerfilUsuarioDetalhes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VChip,VChipGroup,VCol,VIcon,VRow,VTextField})
